<c-card class="progress-tracking-card">
  <c-card-header>
    <h6 class="mb-0">Progress Tracking</h6>
  </c-card-header>
  <c-card-body  style="display: flex; flex-direction: column;">
    <app-polymorphic-control [c]="polyCadenceControl" style="z-index: 3;"></app-polymorphic-control>

    <app-polymorphic-control [c]="polyToleranceControl" (change)="onToleranceChange()"></app-polymorphic-control>

    <c-card class="offcanvas-display-plan" style="z-index: 2;">
      <c-card-header class="d-flex justify-content-end align-items-center gap-2">
        @if (generatedPlan || plan) {
          <button cButton size="sm" variant="outline" color="primary" (click)="onResetPlan()">
            ↺ Regenerate
          </button>
          <button cButton size="sm" variant="outline" color="primary" (click)="onAddPlanItem()">
            + Add Item
          </button>
        }
      </c-card-header>
      
      <optima-lister [list]="listView!" [hasHeader]="listView.items.length > 0" [hasStickyColHeaders]="listView.items.length > 0" [hasColHeaders]="listView.items.length > 0"></optima-lister>

      @if(!generatedPlan){
        <div class="p-3 text-body-secondary">
         <em>No plan generated yet. Set inputs and plan will automatically get generated.</em>
         </div>
         
      }
    </c-card>
  </c-card-body>
</c-card>
